
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DoctorHeader from '@/ui/shared-components/doctor/Header';
import DoctorFooterNav from '@/ui/shared-components/doctor/BottomNav';
import ChatView from '@/components/chat/ChatView';
import ROUTES from '@/routes-map';

const DoctorChatPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-background pb-20">
      <DoctorHeader />
      
      <div className="container mx-auto p-4 pt-20 pb-24">
        <h1 className="text-2xl font-bold mb-4">Patient Messages</h1>
        
        <ChatView
          onNavigateBack={() => navigate(ROUTES.MESSAGES.ROOT)}
          onViewProfile={(id) => navigate(ROUTES.DOCTOR.CASE_FILE.DETAIL(id))}
          onNavigateToPatients={() => navigate(ROUTES.DOCTOR.PATIENTS)}
          userType="doctor"
          conversationId={patientId ? parseInt(patientId) : undefined}
        />
      </div>
      
      <DoctorFooterNav />
    </div>
  );
};

export default DoctorChatPage;
